import {
  setMacAddressesData,
  createMacAddressProfile,
  updateMacAddressProfile,
  deleteMacAddressProfile,
} from "stores/slice/bogus/profiles/macAddress/const";

import {
  createProfilesRadiusServer,
  updateProfilesRadiusServer,
  deleteProfilesRadiusServer,
} from 'stores/slice/bogus/profiles/radiusServer/const';

const profilesConfig = {
  // Profile Ports
  "/ents/:entId/sites/:siteId/settings/profilePorts.read": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesPorts",
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: "profilesPorts",
  },
  "/ents/:entId/sites/:siteId/settings/profilePorts.create": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  "/ents/:entId/sites/:siteId/settings/profilePorts/:portId/profilePorts.update": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  "/ents/:entId/sites/:siteId/settings/profilePorts/:portId/profilePorts.delete": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId/profilePorts.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profilePorts/:portId",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: null,
    mockSelector: null,
  },
  // Profile MAC Addresses
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs.read": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setMacAddressesData,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "read",
    buildParams: (params) => ({ data: params }),
    action: setMacAddressesData,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs.create": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/sites/:siteId/settings/profileMacAddrs/:macGroupId/profileMacAddrs.update": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/profileMacAddrs/:macGroupId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId/profileMacAddrs.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs/:macGroupId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/ents/:entId/:orgs/:orgId/sites/:siteId/settings/profileMacAddrs.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/{orgId}/sites/{siteId}/settings/profileMacAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/profileMacAddrs",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteMacAddressProfile,
    mockSelector: "profilesMacAddress",
  },
  // Profile Radius Server
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.read": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.create": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "create",
    buildParams: (params) => ({ data: params }),
    action: createProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId.update": {
    protocol: "ws",
    resource: "/ents/:entId/sites/:siteId/settings/radiusProfile/:radiusId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile/:radiusId",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params }),
    action: updateProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/radiusProfile.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/{orgId}/sites/{siteId}/settings/radiusProfile",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
  "/orgs/:orgId/sites/:siteId/settings/radiusProfile.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/radiusProfile",
    restful: true,
    method: "delete",
    buildParams: (params) => ({ data: params }),
    action: deleteProfilesRadiusServer,
    mockSelector: "profilesRadiusServer",
  },
};

export default profilesConfig;